import { render, staticRenderFns } from "./PurchasesTableRecapBudgetMediaMax.vue?vue&type=template&id=665eb7b4&scoped=true"
import script from "./PurchasesTableRecapBudgetMediaMax.vue?vue&type=script&lang=js"
export * from "./PurchasesTableRecapBudgetMediaMax.vue?vue&type=script&lang=js"
import style0 from "./PurchasesTableRecapBudgetMediaMax.vue?vue&type=style&index=0&id=665eb7b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665eb7b4",
  null
  
)

export default component.exports